import React, { Suspense } from 'react';
import * as Constants from '../../utilities/constants/Constants';
import CopyrightInfo from './CopyrightInfo/CopyrightInfo';
import MediaQuery from 'react-responsive';
import BottomToolBar from './BottomToolBar/BottomToolBar';

// const BottomBreadcrumb = React.lazy(() =>
//   import('./BottomBreadcrumb/BottomBreadcrumb')
// );
const MiniBottomBar = React.lazy(() =>
  import('./BottomBreadcrumb/MiniBottomBar')
);

const Footer = props => {
  const {
    sidebarIsHiddenInDesktop,
    page,
    showSideBar,
    handleSideBar,
    isFranceAccount
  } = props;
  // function classforBottomBar() {
  //   if (
  //     (page === Constants.DESIGN_PAGE ||
  //       page === Constants.FILE_PROCESSING_PAGE ||
  //       page === Constants.DESIGN_SHARE_PAGE) &&
  //     !sidebarIsHiddenInDesktop
  //   ) {
  //     return 'bottom-bar-design-page';
  //   }
  //   return 'home';
  // }

  return (
    <Suspense
      fallback={
        <div className=' loading-indicator-suspense-fallback' id='loader' />
      }
    >
      <MediaQuery query='(max-width: 767px)'>
        {page === Constants.DESIGN_PAGE ? (
          <MiniBottomBar
            handleSideBar={handleSideBar}
            showSideBar={showSideBar}
            sidebarIsHiddenInDesktop={sidebarIsHiddenInDesktop}
          />
        ) : null}
      </MediaQuery>
      <MediaQuery query='(min-width: 767px)'>
        {/* <BottomBreadcrumb customClass={classforBottomBar()} /> */}
        {page === Constants.DESIGN_PAGE && <BottomToolBar />}
      </MediaQuery>
      <CopyrightInfo isFranceAccount={isFranceAccount} />
    </Suspense>
  );
};

export default Footer;
